var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6095_49051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.57499 7.50521C7.77091 6.94827 8.15762 6.47863 8.66662 6.17949C9.17562 5.88034 9.77407 5.77099 10.356 5.8708C10.9379 5.97061 11.4657 6.27315 11.8459 6.72482C12.2261 7.17649 12.4342 7.74814 12.4333 8.33854C12.4333 10.0052 9.93332 10.8385 9.93332 10.8385M9.99999 14.1719H10.0083M18.3333 10.0052C18.3333 14.6076 14.6024 18.3385 9.99999 18.3385C5.39762 18.3385 1.66666 14.6076 1.66666 10.0052C1.66666 5.40284 5.39762 1.67188 9.99999 1.67188C14.6024 1.67188 18.3333 5.40284 18.3333 10.0052Z",
    stroke: "#4A5564",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6095_49051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3a027518.svg";
export { ForwardRef as ReactComponent };